import React, { Fragment, useState, useEffect } from 'react';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import Modal from '@material-ui/core/Modal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faCheck, faBan, faTrashAlt, faDownload, faCloudDownloadAlt } from "@fortawesome/free-solid-svg-icons";
import AlertModal from '../../../../shared/components/Modal';

const AttachFileTableActions = ({ data, state, callbackRadioPharmacy, callbackTenCorrect, Callback,sendNotificationDiagnosticImage }) => {

  useEffect(() => {
  }, [])

  const [showPdf, setShowPdf] = useState(false);
  const [showAlertModal, setShowAlertModal] = React.useState(false);
  const [messagAlerteModal, setAlertMessageModal] = React.useState(null);
  const [colorAlertModal, setAlertColorModal] = React.useState("info");

  const changeSelectedImage = async (selected) => {
    let dataSend = {
      id_admision: data.data.original.id_admision,
      id: data.data.original.id,
      seleccion: selected
    }
    await fetch(process.env.REACT_APP_PUBLIC_URL + 'archivos/cambiar-seleccion', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body: JSON.stringify(dataSend)
    }).then(response => {
      if (response.status != 500 && response.status != 403) {
        return response.json();
      }
      else {
        throw new Error("Ha ocurrido un error en el Servidor");
      }
    }).then(data => {
      Callback();
      if(selected)
      {
        sendNotificationDiagnosticImage();
      }
    }).catch((error) => {
      console.error(error);
    });
  }

  const confirmDeleteFile = async () => {
    setShowAlertModal(false);
    setAlertColorModal("info");
    setAlertMessageModal("");

    let dataSend = {
      id_admision: data.data.original.id_admision,
      id: data.data.original.id
    }

    await fetch(process.env.REACT_APP_PUBLIC_URL + 'archivos/eliminar-fichero', {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body: JSON.stringify(dataSend)
    }).then(response => {
      if (response.status != 500 && response.status != 403 && response.status != 404) {
        setShowAlertModal(true);
        setAlertColorModal("success");
        setAlertMessageModal("Archivo Eliminado con Exito");
      }
      else {
        throw new Error("Ha ocurrido un error en el Servidor");
      }
    }).catch((error) => {
      setShowAlertModal(true);
      setAlertColorModal("danger");
      setAlertMessageModal("Ha ocurrido un error en el Servidor");
      console.error(error);
    });
  }

  const downloadFile = async () => {
    try {
      const response = await fetch(process.env.REACT_APP_PUBLIC_URL + data.data.original.ruta + sessionStorage.getItem('token'));
      if (!response.ok) {
        throw new Error('Imagen no encontrada en el servidor');
      }

      const blob = await response.blob(); // Get the file data as a Blob
      const downloadableURL = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadableURL;
      link.download = data.data.original.nombre;
      link.click();
  
      window.URL.revokeObjectURL(downloadableURL);
    } catch (error) {
      console.error('Failed to download file:', error);
    }
  }

  return (<Fragment>
    <td role="cell">
      <Tooltip title="Ver">
        <IconButton aria-label="unable" style={{ padding: 2 }}
          onClick={() => {
            setShowPdf(true);
          }}>
          <FontAwesomeIcon icon={faEye} style={{ margin: '0px 5px 0px 5px', width: 20 }} />
        </IconButton>
      </Tooltip>
      {
        data.data.original.clase == "IMAGENOLOGIA" ?
          <>
            {
              data.data.original.seleccionado == false ? <Tooltip title="Seleccionar Imagen Diagnostica">
                <IconButton aria-label="unable" style={{ padding: 2 }}
                  onClick={() => {
                    changeSelectedImage(true);
                  }}>
                  <FontAwesomeIcon icon={faCheck} style={{ margin: '0px 5px 0px 5px', width: 20 }} />
                </IconButton>
              </Tooltip> : <Tooltip title="Retirar Imagen Diagnostica">
                <IconButton aria-label="unable" style={{ padding: 2 }}
                  onClick={() => {
                    changeSelectedImage(false);
                  }}>
                  <FontAwesomeIcon icon={faBan} style={{ margin: '0px 5px 0px 5px', width: 20 }} />
                </IconButton>
              </Tooltip>
            }
          </>
          : null
      }
      <Tooltip title="Eliminar Archivo">
        <IconButton aria-label="unable" style={{ padding: 2 }}
          onClick={() => {
            setAlertColorModal("warning");
            setAlertMessageModal("Esta seguro que desea eliminar este archivo?");
            setShowAlertModal(true);
          }}>
          <FontAwesomeIcon icon={faTrashAlt} style={{ margin: '0px 5px 0px 5px', width: 20 }} />
        </IconButton>
      </Tooltip>
      <Tooltip title="Descargar Archivo">
        <IconButton aria-label="unable" style={{ padding: 2 }} onClick={() => downloadFile()}>
          <FontAwesomeIcon icon={faCloudDownloadAlt} style={{ margin: '0px 5px 0px 5px', width: 20 }} />
        </IconButton>
      </Tooltip>

      {showPdf ?
        <Modal
          open={showPdf}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          style={{ zIndex: 1000 }}
        >
          <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
            <IconButton style={{ float: 'right' }} onClick={() => {
              setShowPdf(false);
            }}>
              <CloseIcon />
            </IconButton>
            <iframe id="pdfV" width="1000" height="700" src={process.env.REACT_APP_PUBLIC_URL + data.data.original.ruta + sessionStorage.getItem('token')} >
            </iframe>
          </div>
        </Modal>
        : null}

      <AlertModal
        color={colorAlertModal}
        title={messagAlerteModal}
        modal={showAlertModal}
        onOk={() => {
          switch (colorAlertModal) {
            case 'success':
              setShowAlertModal(false);
              setAlertColorModal("info");
              setAlertMessageModal("");
              Callback();
              break;
            case 'warning':
              confirmDeleteFile();
              break;
            case 'danger':
              setShowAlertModal(false);
              setAlertColorModal("info");
              setAlertMessageModal("");
              break;
          }
        }}
        toggle={() => {
          setShowAlertModal(false);
          switch (colorAlertModal) {
            case 'success':
              setAlertColorModal("info");
              setAlertMessageModal("");
              Callback();
              break;
          }
        }}
      />
    </td>
  </Fragment>)
}

export default AttachFileTableActions;